import pluralize from "pluralize";

import {KPICard} from "@/components/KPICard/KPICard.tsx";
import {durationSecFn, roundDurationSecs} from "@/lib/format.tsx";

interface StatHeaderDowntimeProps {
  downtimeSecs: number;
  outages: number;
}

export const StatHeaderDowntime = ({downtimeSecs, outages}: StatHeaderDowntimeProps) => {
  const downtimeNotes = downtimeSecs !== 0 ? ` - ${outages} ${pluralize("outage", outages)}` : "";
  return (
    <KPICard title={`Downtime${downtimeNotes}`}>
      {downtimeSecs === 0 ? "None recorded" : durationSecFn(roundDurationSecs(downtimeSecs))}
    </KPICard>
  );
};
